import { BaseRequests } from "../../../config/BaseRequests";
import { usersApiEndpoints } from "../api/users.api";
import {
  UserRow,
  UserReservationRow,
  SuspendUserResponse,
} from "../dto/index.dto";
import { PaginatedResponse } from "../../../shared/dto/pagination.dto";

export class UsersService {
  static getUsers = (
    page: number,
    limit: number
  ): Promise<PaginatedResponse<UserRow>> =>
    BaseRequests.get(usersApiEndpoints.getUsers(page, limit));

  static suspendUser = (userId: string): Promise<SuspendUserResponse> =>
    BaseRequests.patch(usersApiEndpoints.suspendUser(userId));

  static reactivateUser = (userId: string): Promise<SuspendUserResponse> =>
    BaseRequests.patch(usersApiEndpoints.reactivateUser(userId));

  static getUserReservations = (
    userId: string,
    event: string,
    page: number,
    limit: number
  ): Promise<PaginatedResponse<UserReservationRow>> =>
    BaseRequests.get(
      usersApiEndpoints.getUserReservations(userId, event, page, limit)
    );
}
